import React from 'react';

import { CutoutLine } from '../CutoutLine';
import classNames from './PageTitle.module.scss';

export type Props = {
  main: string;
  sub: string;
};

export const PageTitle: React.FC<Props> = ({ main, sub }) => {
  return (
    <div className={`${classNames['page-title']} reset-position`}>
      <img
        className={classNames['background-image']}
        src="/public/images/Mask_Group_14_bw.png"
      />
      <div className={classNames['main-text']}>{main}</div>
      <div className={classNames['sub-text']}>{sub}</div>
      <svg className={classNames.cutout} viewBox="-3853.621 -8968.02 312 73">
        <path
          className={classNames['cutout-path']}
          d="M -3853.62060546875 -8968.01953125 L -3541.62060546875 -8968.01953125 L -3559.880615234375 -8895.01953125 L -3853.62060546875 -8968.01953125 Z"
        />
      </svg>
      <CutoutLine width={720} top={210} left={-60} from="left" />
    </div>
  );
};
